export type ActionError = any;

export interface StateSlice<T, E = ActionError> {
  readonly data: T;
  readonly loading: boolean;
  readonly loaded: boolean;
  readonly error: E;
}
